import { atom } from 'jotai';

// Atom to store the current user data
export const currentUserAtom = atom(null);

// Atom to track if authentication is fully loaded
export const authLoadedAtom = atom(false);
